import { View } from 'react-native';
import { RedeemCard } from '../components/lite/RedeemComponent';
import { HistoryList } from './HistoryList';
import { TokenCard } from './TokenCard';
export function GameCenterHistory() {
  return (
    <View>
      <TokenCard />
      <RedeemCard />
      <HistoryList />
    </View>
  );
}
